package ui.styles.icons

import emotion.react.css
import react.FC
import react.Props
import react.dom.svg.ReactSVG
import web.cssom.Rotate
import web.cssom.Scale
import web.cssom.deg

private val plusIc = "_icon"

private enum class HandlerSVG(
    val id: String,
    val pathD: String,
    val description: String,
    val owWidth:Double? = null,
    val owHeight:Double? = null,
    val owViewBox:String? = null
){
    APP_ICON(
        id = "app_icon$plusIc",
        pathD = "M292.522 104.609C310.144 104.609 324.434 118.897 324.434 136.518V179.063C324.434 196.684 310.144 210.972 292.522 210.972H269.475V104.609H292.522ZM0 37.245V278.336H72.6873V104.609H117.009V278.336H189.696V37.245H0ZM398.894 0.0177273V37.245V278.336H473.354V179.063H474.772L515.672 277.698L516.789 278.318L517.676 278.336H601V275.375L540.723 151.941L601 40.0282V37.245H514.13V37.2273L513.155 37.8477L471.581 110.813V37.2273V0L398.894 0.0177273ZM202.106 37.245V276.563V301.364V324.409V351H269.475V324.409V301.364V276.563H301.386C350.335 276.563 390.03 236.872 390.03 187.927V125.881C390.03 76.9365 350.335 37.245 301.386 37.245H202.106Z",
        description = "Иконка приложения",
        owWidth = 600.0,
        owHeight = 350.0,
        owViewBox = "0 0 600 350"
    ),
    APP_LOGO(
        id = "app_logo$plusIc",
        pathD = "m309 73.85v0.15h-0.09l0.09 -0.15zm-125 -7.85c9.94 0 18 8.06 18 18v24c0 9.94 -8.06 18 -18 18h-13v-60zm-165 -38v136h41v-98h25v98h41v-136zm225 -28v28v136h42v-56h0.8l23.07 55.64l1.13 -0.47v0.83h47v-1.67l-34 -69.63l34 -63.13v-1.57h-49v0.66l-0.55 -0.32l-23.45 41.16v-41.51v-28zm-232 0c-6.63 0 -12 5.37 -12 12v177c0 6.63 5.37 12 12 12h117v-9h-112c-4.42 0 -8 -3.58 -8 -8v-166c0 -4.42 3.58 -8 8 -8h223v-10zm277 0v10h69c4.42 0 8 3.58 8 8v166c0 4.42 -3.58 8 -8 8h-183v9h188c6.63 0 12 -5.37 12 -12v-177c0 -6.63 -5.37 -12 -12 -12zm-156 28v135v29v13v15h38v-15v-13v-29h18c27.61 0 50 -22.39 50 -50v-35c0 -27.61 -22.39 -50 -50 -50z",
        description = "Логотип приложения",
        owWidth = 375.0,
        owHeight = 220.0,
        owViewBox = "0 0 375 220"
    ),
    MENU_ROUNDED(
        id = "menu_rounded$plusIc",
        pathD = "M160-240q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h640q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240H160Zm0-200q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h640q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H160Zm0-200q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h640q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H160Z",
        description = "Открыть меню"
    ),
    CLOSE_ROUNDED(
        id = "close_rounded$plusIc",
        pathD = "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z",
        description = "Закрыть"
    ),
    EXPAND_CONTENT(
        id = "expand_content$plusIc",
        pathD = "M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z",
        description = "Подробно"
    ),
    EDIT_NOTE_ROUNDED(
        id = "edit_note_rounded$plusIc",
        pathD = "M200-400q-17 0-28.5-11.5T160-440q0-17 11.5-28.5T200-480h200q17 0 28.5 11.5T440-440q0 17-11.5 28.5T400-400H200Zm0-160q-17 0-28.5-11.5T160-600q0-17 11.5-28.5T200-640h360q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560H200Zm0-160q-17 0-28.5-11.5T160-760q0-17 11.5-28.5T200-800h360q17 0 28.5 11.5T600-760q0 17-11.5 28.5T560-720H200Zm320 520v-66q0-8 3-15.5t9-13.5l209-208q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L655-172q-6 6-13.5 9t-15.5 3h-66q-17 0-28.5-11.5T520-200Zm300-223-37-37 37 37ZM580-220h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z",
        description = "Изменить"
    ),
    ARROW_BACK_ROUNDED(
        id = "arrow_back_rounded$plusIc",
        pathD = "m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z",
        description = "Назад"
    ),
    LIGHT_MODE_ROUNDED(
        id = "light_mode_rounded$plusIc",
        pathD = "M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM80-440q-17 0-28.5-11.5T40-480q0-17 11.5-28.5T80-520h80q17 0 28.5 11.5T200-480q0 17-11.5 28.5T160-440H80Zm720 0q-17 0-28.5-11.5T760-480q0-17 11.5-28.5T800-520h80q17 0 28.5 11.5T920-480q0 17-11.5 28.5T880-440h-80ZM480-760q-17 0-28.5-11.5T440-800v-80q0-17 11.5-28.5T480-920q17 0 28.5 11.5T520-880v80q0 17-11.5 28.5T480-760Zm0 720q-17 0-28.5-11.5T440-80v-80q0-17 11.5-28.5T480-200q17 0 28.5 11.5T520-160v80q0 17-11.5 28.5T480-40ZM226-678l-43-42q-12-11-11.5-28t11.5-29q12-12 29-12t28 12l42 43q11 12 11 28t-11 28q-11 12-27.5 11.5T226-678Zm494 495-42-43q-11-12-11-28.5t11-27.5q11-12 27.5-11.5T734-282l43 42q12 11 11.5 28T777-183q-12 12-29 12t-28-12Zm-42-495q-12-11-11.5-27.5T678-734l42-43q11-12 28-11.5t29 11.5q12 12 12 29t-12 28l-43 42q-12 11-28 11t-28-11ZM183-183q-12-12-12-29t12-28l43-42q12-11 28.5-11t27.5 11q12 11 11.5 27.5T282-226l-42 43q-11 12-28 11.5T183-183Zm297-297Z",
        description = "Светлая тема"
    ),
    DARK_MODE_ROUNDED(
        id = "dark_mode_rounded$plusIc",
        pathD = "M480-120q-151 0-255.5-104.5T120-480q0-138 90-239.5T440-838q13-2 23 3.5t16 14.5q6 9 6.5 21t-7.5 23q-17 26-25.5 55t-8.5 61q0 90 63 153t153 63q31 0 61.5-9t54.5-25q11-7 22.5-6.5T819-479q10 5 15.5 15t3.5 24q-14 138-117.5 229T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z",
        description = "Темная тема"
    ),
    ARROW_DOWN_ROUNDED(
        id = "arrow_down_rounded$plusIc",
        pathD = "M480-361q-8 0-15-2.5t-13-8.5L268-556q-11-11-11-28t11-28q11-11 28-11t28 11l156 156 156-156q11-11 28-11t28 11q11 11 11 28t-11 28L508-372q-6 6-13 8.5t-15 2.5Z",
        description = "NULL"
    ),
    BLUR_ON_ROUNDED(
        id = "blur_on_rounded$plusIc",
        pathD = "M120-380q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm0-160q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm120 340q-17 0-28.5-11.5T200-240q0-17 11.5-28.5T240-280q17 0 28.5 11.5T280-240q0 17-11.5 28.5T240-200Zm0-160q-17 0-28.5-11.5T200-400q0-17 11.5-28.5T240-440q17 0 28.5 11.5T280-400q0 17-11.5 28.5T240-360Zm0-160q-17 0-28.5-11.5T200-560q0-17 11.5-28.5T240-600q17 0 28.5 11.5T280-560q0 17-11.5 28.5T240-520Zm0-160q-17 0-28.5-11.5T200-720q0-17 11.5-28.5T240-760q17 0 28.5 11.5T280-720q0 17-11.5 28.5T240-680Zm160 340q-25 0-42.5-17.5T340-400q0-25 17.5-42.5T400-460q25 0 42.5 17.5T460-400q0 25-17.5 42.5T400-340Zm0-160q-25 0-42.5-17.5T340-560q0-25 17.5-42.5T400-620q25 0 42.5 17.5T460-560q0 25-17.5 42.5T400-500Zm0 300q-17 0-28.5-11.5T360-240q0-17 11.5-28.5T400-280q17 0 28.5 11.5T440-240q0 17-11.5 28.5T400-200Zm0-480q-17 0-28.5-11.5T360-720q0-17 11.5-28.5T400-760q17 0 28.5 11.5T440-720q0 17-11.5 28.5T400-680Zm0 580q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm0-720q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm160 480q-25 0-42.5-17.5T500-400q0-25 17.5-42.5T560-460q25 0 42.5 17.5T620-400q0 25-17.5 42.5T560-340Zm0-160q-25 0-42.5-17.5T500-560q0-25 17.5-42.5T560-620q25 0 42.5 17.5T620-560q0 25-17.5 42.5T560-500Zm0 300q-17 0-28.5-11.5T520-240q0-17 11.5-28.5T560-280q17 0 28.5 11.5T600-240q0 17-11.5 28.5T560-200Zm0-480q-17 0-28.5-11.5T520-720q0-17 11.5-28.5T560-760q17 0 28.5 11.5T600-720q0 17-11.5 28.5T560-680Zm0 580q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm0-720q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm160 620q-17 0-28.5-11.5T680-240q0-17 11.5-28.5T720-280q17 0 28.5 11.5T760-240q0 17-11.5 28.5T720-200Zm0-160q-17 0-28.5-11.5T680-400q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400q0 17-11.5 28.5T720-360Zm0-160q-17 0-28.5-11.5T680-560q0-17 11.5-28.5T720-600q17 0 28.5 11.5T760-560q0 17-11.5 28.5T720-520Zm0-160q-17 0-28.5-11.5T680-720q0-17 11.5-28.5T720-760q17 0 28.5 11.5T760-720q0 17-11.5 28.5T720-680Zm120 300q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm0-160q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Z",
        description = "NULL"
    )
}

external interface HandlerSVGProps: Props {
    var pl: Map<String, String>
}


class IconsSVG (
    var id: String,
    private val pathD: String,
    val description: String,
    private val owWidth: Double? = null,
    private val owHeight: Double? = null,
    private val owViewBox: String? = null
){
    val iconSVG = FC<HandlerSVGProps> {props->
        val trId = if (props.pl != undefined) props.pl.get("id") else null
        val trRotate = if (props.pl != undefined) props.pl.get("rotate") else null
        val trScale = if (props.pl != undefined) props.pl.get("scale") else null
        val trFill = if (props.pl != undefined) props.pl.get("fill") else null

        ReactSVG.svg{
            this.id = this@IconsSVG.id.plus(trId)
            this.xmlns = "http://www.w3.org/2000/svg"
            this.viewBox = owViewBox ?: "0 -960 960 960"
            this.width = owWidth ?: 24.0
            this.height = owHeight ?: 24.0
            this.fill = trFill ?: "white"
            this.css {
                rotate = (trRotate?.toInt()?.deg ?: 0.deg).unsafeCast<Rotate>()
                scale = (trScale?.toInt() ?: 1 ).unsafeCast<Scale>()
            }

            ReactSVG.path{
                this.d = pathD
            }
        }
    }
}

val MenuRoundedIconSVG = IconsSVG(
    id = HandlerSVG.MENU_ROUNDED.id,
    pathD = HandlerSVG.MENU_ROUNDED.pathD,
    description = HandlerSVG.MENU_ROUNDED.description
)
val CloseRoundedIconSVG = IconsSVG(
    id = HandlerSVG.CLOSE_ROUNDED.id,
    pathD = HandlerSVG.CLOSE_ROUNDED.pathD,
    description = HandlerSVG.CLOSE_ROUNDED.description
)
val AppLOGOIconSVG = IconsSVG(
    id = HandlerSVG.APP_LOGO.id,
    pathD = HandlerSVG.APP_LOGO.pathD,
    description = HandlerSVG.APP_LOGO.description,
    owWidth = HandlerSVG.APP_LOGO.owWidth,
    owHeight = HandlerSVG.APP_LOGO.owHeight,
    owViewBox = HandlerSVG.APP_LOGO.owViewBox
)
val AppIconIconSVG = IconsSVG(
    id = HandlerSVG.APP_ICON.id,
    pathD = HandlerSVG.APP_ICON.pathD,
    description = HandlerSVG.APP_ICON.description,
    owWidth = HandlerSVG.APP_ICON.owWidth,
    owHeight = HandlerSVG.APP_ICON.owHeight,
    owViewBox = HandlerSVG.APP_ICON.owViewBox
)
val ExpandContentIconSVG = IconsSVG(
    id = HandlerSVG.EXPAND_CONTENT.id,
    pathD = HandlerSVG.EXPAND_CONTENT.pathD,
    description = HandlerSVG.EXPAND_CONTENT.description
)
val EditNoteIconSVG = IconsSVG(
    id = HandlerSVG.EDIT_NOTE_ROUNDED.id,
    pathD = HandlerSVG.EDIT_NOTE_ROUNDED.pathD,
    description = HandlerSVG.EDIT_NOTE_ROUNDED.description
)
val ArrowBackIconSVG = IconsSVG(
    id = HandlerSVG.ARROW_BACK_ROUNDED.id,
    pathD = HandlerSVG.ARROW_BACK_ROUNDED.pathD,
    description = HandlerSVG.ARROW_BACK_ROUNDED.description
)
val LightModeIconSVG = IconsSVG(
    id = HandlerSVG.LIGHT_MODE_ROUNDED.id,
    pathD = HandlerSVG.LIGHT_MODE_ROUNDED.pathD,
    description = HandlerSVG.LIGHT_MODE_ROUNDED.description
)
val DarkModeIconSVG = IconsSVG(
    id = HandlerSVG.DARK_MODE_ROUNDED.id,
    pathD = HandlerSVG.DARK_MODE_ROUNDED.pathD,
    description = HandlerSVG.DARK_MODE_ROUNDED.description
)
val ArrowDownRoundedIconSVG = IconsSVG(
    id = HandlerSVG.ARROW_DOWN_ROUNDED.id,
    pathD = HandlerSVG.ARROW_DOWN_ROUNDED.pathD,
    description = HandlerSVG.ARROW_DOWN_ROUNDED.description,
    owHeight = 20.0
)
val BlurOnRoundedIconSVG = IconsSVG(
    id = HandlerSVG.BLUR_ON_ROUNDED.id,
    pathD = HandlerSVG.BLUR_ON_ROUNDED.pathD,
    description = HandlerSVG.BLUR_ON_ROUNDED.description
)